import { API_BASE_URL } from "@/config";
import { validateToken } from "@/utils/auth";

export default {
  name: "TrustSearchForm",
  data() {
    return {
      form: {
        trust_name: "",
      },
      trust_results: null,
      selected_trust_id: null,
      new_trust: {
        trust_name: "",
        file_number: "",
        masters_office: "",
        authorisation_date: "",
      },
      masters_offices: [
        "Pretoria Masters Office",
        "Cape Town Masters Office", 
        "Durban Masters Office",
        "Johannesburg Masters Office",
        "Bloemfontein Masters Office",
        "Port Elizabeth Masters Office",
        "Kimberley Masters Office",
        "Pietermaritzburg Masters Office",
        "Thohoyandou Masters Office",
        "Mmabatho Masters Office",
        "Nelspruit Masters Office",
        "Grahamstown Masters Office",
        "Mthatha Masters Office",
      ],
      loading: false,
      showError: false,
      auto_submitted: false,
    };
  },
  
  emits: ["service_status_complete", "trust_selected"],
  
  computed: {
    should_auto_submit() {
      return this.form.trust_name && !this.auto_submitted;
    },
  },

  methods: {
    // Main search submission - similar to flex trust
    submit_trust_name() {
      this.showError = false;
      this.auto_submitted = false;

      if (!this.form.trust_name.trim()) {
        this.showError = true;
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Trust name cannot be empty!",
          timer: 3000,
          showConfirmButton: false,
        });
        return false;
      }

      this.trust_search_api();
    },

    // API call for trust search - combining both approaches
    trust_search_api() {
      const TOKEN = localStorage.getItem("token");
      const TRUST_NAME_SEARCH_API = `${API_BASE_URL}/verify_api/instant_verify_api/trust_search/`;

      this.auto_submitted = true;
      this.loading = true;
      this.showError = false;

      const DATA = {
        trust_name: this.form.trust_name,
      };

      Swal.fire({
        title: "Searching Trusts",
        text: "Please wait while we search for trust information...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      $.ajax({
        url: TRUST_NAME_SEARCH_API,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(DATA),
        success: (response) => {
          Swal.close();
          this.loading = false;

          if (response.status === "success" && response.response) {
            this.trust_results = response.response;
            
            // If no results found, show empty array to display "No Results" message
            if (this.trust_results.length === 0) {
              Swal.fire({
                icon: "info",
                title: "No Results",
                text: "No trusts found matching your search criteria.",
                timer: 3000,
                showConfirmButton: false,
              });
            }
          } else {
            this.trust_results = [];
            Swal.fire({
              icon: "info",
              title: "No Results",
              text: "No trusts found matching your search criteria.",
              timer: 3000,
              showConfirmButton: false,
            });
          }
        },
        error: (error) => {
          this.loading = false;
          this.auto_submitted = false;
          Swal.close();

          let error_message = "Something went wrong!";
          if (error.responseJSON && error.responseJSON.message) {
            error_message = error.responseJSON.message;
          }

          Swal.fire({
            icon: "error",
            title: "Search Error",
            text: error_message,
            timer: 3000,
            showConfirmButton: false,
          });
        },
      });
    },

    // Optional method to save trust selection if needed later
    save_trust_selection(trust_id) {
      const TOKEN = localStorage.getItem("token");
      const SAVE_TRUST_API = `${API_BASE_URL}/verify_api/instant_verify_api/trust_data_fetch/`;

      this.loading = true;

      const DATA = {
        trust_id: trust_id,
      };

      $.ajax({
        url: SAVE_TRUST_API,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(DATA),
        beforeSend: () => {
          Swal.fire({
            text: "Saving trust information...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });
        },
        success: (response) => {
          Swal.close();
          this.loading = false;

          // Emit completion event to parent
          this.$emit("service_status_complete", {
            trust_id: trust_id,
            response: response
          });
        },
        error: (error) => {
          this.loading = false;
          Swal.close();

          let error_message = "Could not save trust information!";
          if (error.responseJSON && error.responseJSON.message) {
            error_message = error.responseJSON.message;
          }

          Swal.fire({
            icon: "error",
            title: "Error",
            text: error_message,
            timer: 3000,
            showConfirmButton: false,
          });
        },
      });
    },

    // Add new trust functionality - similar to flex trust
    add_new_trust() {
      if (!this.new_trust.trust_name || !this.new_trust.file_number || 
          !this.new_trust.masters_office || !this.new_trust.authorisation_date) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Please fill in all required fields",
          timer: 3000,
          showConfirmButton: false,
        });
        return;
      }

      const TOKEN = localStorage.getItem("token");
      const ADD_TRUST_API = `${API_BASE_URL}/verify_api/instant_verify_api/add_trust/`;

      this.loading = true;

      $.ajax({
        url: ADD_TRUST_API,
        method: "POST",
        contentType: "application/json",
        headers: {
          Authorization: `Token ${TOKEN}`,
        },
        data: JSON.stringify(this.new_trust),
        beforeSend: () => {
          Swal.fire({
            text: "Adding new trust...",
            allowEscapeKey: false,
            allowOutsideClick: false,
            didOpen: () => Swal.showLoading(),
          });
        },
        success: (response) => {
          Swal.close();
          this.loading = false;
          
          Swal.fire({
            icon: "success",
            title: "Trust Added",
            text: "New trust has been added successfully.",
            timer: 3000,
            showConfirmButton: false,
          });

          // Reset form
          this.new_trust = {
            trust_name: "",
            file_number: "",
            masters_office: "",
            authorisation_date: "",
          };

          // Emit completion
          this.$emit("service_status_complete", {
            action: "trust_added",
            response: response
          });
        },
        error: (error) => {
          this.loading = false;
          Swal.close();

          let error_message = "Could not add trust!";
          if (error.responseJSON && error.responseJSON.message) {
            error_message = error.responseJSON.message;
          }

          Swal.fire({
            icon: "error", 
            title: "Error",
            text: error_message,
            timer: 3000,
            showConfirmButton: false,
          });
        },
      });
    },

    // Reset search - similar to flex trust
    reset_search() {
      this.trust_results = null;
      this.form.trust_name = "";
      this.selected_trust_id = null;
      this.showError = false;
      this.auto_submitted = false;
    },

    // Get selected trust details
    get_selected_trust_details() {
      if (!this.selected_trust_id || !this.trust_results) {
        return null;
      }
      return this.trust_results.find(trust => trust.TrustID === this.selected_trust_id);
    },

    // Public method to trigger trust data fetch if needed
    fetch_trust_data(trust_id = null) {
      const id = trust_id || this.selected_trust_id;
      if (id) {
        this.save_trust_selection(id, true);
      }
    }
  },

  mounted() {
    if (!validateToken(this.$router)) {
      return;
    }

    // Auto-submit if trust name is pre-populated (similar to flex trust)
    if (this.should_auto_submit) {
      this.$nextTick(() => {
        this.submit_trust_name();
      });
    }
  },
};